import BillingAddressModel from "../model/billing_address_model";

export const toBillingAddressModel = async (billingAddress, encryptionService) => {
  const decryptedData = await encryptionService.decrypt(billingAddress);
  return new BillingAddressModel({
    id: decryptedData._id,
    firstName: decryptedData.firstName,
    lastName: decryptedData.lastName,
    address: decryptedData.address1,
    city: decryptedData.city,
    state: decryptedData.state,
    zip: decryptedData.zip,
    country: decryptedData.country,
    phone: decryptedData.phone,
  });
};
